const fetchJsonp = require('fetch-jsonp');
const ClientSideStorageWrapper = require('./ClientSideStorageWrapper');
const ExpUtils = require('./ExpUtils');
const Experimentation = require('./Experimentation');

const TagManagerUtil = require('../tagManager');
const { Cookie } = require('../cookie');

module.exports = class ExperimentationTags {
  /**
    * Use Case: Adobe Auto Tagging on page load
    */
  static fireAdobeTags = async () => {
    await this.fireDesktopAdobeTagsAsync();
  };

  static async fireDesktopAdobeTagsAsync() {
    const finalRecipes = await this.getFinalClientRecipesAsync();
    // debugger;
    const filterFinalRecipes = [];
    let sessionRecipes = [];
    let sessionRecipesList = [];
    const updatedRecipes = [];
    const expTagsSession = ClientSideStorageWrapper.getExpTagsSession(ExpUtils.PROPS.COMMON.expTagsFiredSessionKey);
    if (expTagsSession && !ClientSideStorageWrapper.isExpTagsSessionExpired()) {
      // debugger;
      await finalRecipes.forEach((recipe) => {
        // debugger;
        sessionRecipes = expTagsSession.split('|')[0];
        if (sessionRecipes) {
          sessionRecipesList = sessionRecipes.split(',');
        }
        if (!sessionRecipesList.includes(recipe)) {
          filterFinalRecipes.push(recipe);
        }
      });

      // debugger;
      const data = {
        event_name: 'experiment',
        expsdk_source: 'vue',
        experimentation_ids: filterFinalRecipes,
      };
      if (filterFinalRecipes.length > 0) {
        await TagManagerUtil.fireTag('link', data);
      }
      // debugger;
      if (sessionRecipesList.length > 0) {
        updatedRecipes.push(sessionRecipesList);
      }
      if (filterFinalRecipes.length > 0) {
        updatedRecipes.push(filterFinalRecipes);
      }
      const existingTtl = expTagsSession.split('|')[1];
      const updatedExp = `${updatedRecipes}|${existingTtl}`;
      ClientSideStorageWrapper.setExpTagsSession(ExpUtils.PROPS.COMMON.expTagsFiredSessionKey, updatedExp);
    } else {
      // debugger;
      const data2 = {
        event_name: 'experiment',
        expsdk_source: 'vue',
        experimentation_ids: finalRecipes,
      };
      if (finalRecipes.length > 0) {
        await TagManagerUtil.fireTag('link', data2);
      }
      const ttl = new Date().getTime() + ExpUtils.PROPS.COMMON.expTagssessionTTL;
      const exp = `${finalRecipes}|${ttl}`;
      ClientSideStorageWrapper.setExpTagsSession(ExpUtils.PROPS.COMMON.expTagsFiredSessionKey, exp);
    }
  }

  /**
   * Get SEED recipeIds which have adobeAutoTagging enabled
   * @returns
   */
  static getFinalClientRecipesAsync = async () => {
    await this.getAllSelectedRecipesAsync();

    const session = ClientSideStorageWrapper.getExpSession(ExpUtils.PROPS.COMMON.expSessionKey);
    // Get receipeIds from SEED Cookie
    const allSeedExps = Experimentation.getExpIds();
    const finalClientRecipes = [];
    // SEED recipes which have adobeAutoTagging enabled
    if (session) {
      allSeedExps.forEach((exp) => {
        const expId = exp.split('-', 1);
        if (session[expId] && session[expId].taggingProvider) {
          if (session[expId].taggingProvider === 'Both' || session[expId].taggingProvider === 'Adobe') {
            if (session[expId].adobeAutoTagging === true
              || session[expId].adobeAutoTagging === null
              || session[expId].adobeAutoTagging === undefined) {
              finalClientRecipes.push(exp);
            }
          }
        }
      });
    }
    return finalClientRecipes;
  }

  /**
   * Get selectedRecipeIds from session (key ExpMetaData)
   * @returns array of receipeIds
   * Session ExpMetaData keeps v2/filteredExperiments response
   */
  static getAllSelectedRecipesAsync = async () => {
    let expArray = [];
    const session = ClientSideStorageWrapper.getExpSession(ExpUtils.PROPS.COMMON.expSessionKey);
    if (!session || ClientSideStorageWrapper.isExpSessionExpired() || !this.isSignedInSame()) {
      const newSession = await this.fetchExpDataAsync();
      if (newSession === Object(newSession) && newSession.selectedRecipes) {
        expArray = newSession.selectedRecipes;
      }
      return expArray;
    } if (session.selectedRecipes) {
      // Desktop Session data present , find it in the session.
      return session.selectedRecipes;
    }
    return expArray;
  };

  /**
   * Get session  (key ExpMetaData)
   * The session must have v2/filteredExperiments API response
   * @returns session
   */
  static fetchExpDataAsync = async () => {
    const api = ExpUtils.getApiEndpoint();

    const session = ClientSideStorageWrapper.getExpSession(ExpUtils.PROPS.COMMON.expSessionKey);
    // if meta data already exists in session storage &&
    // session NOT expired
    if (session && !ClientSideStorageWrapper.isExpSessionExpired() && this.isSignedInSame()) {
      return session;
    } if (api !== undefined && api !== null) {
      await this.callExperimentationAPIAsync();

      const newSession = ClientSideStorageWrapper.getExpSession(ExpUtils.PROPS.COMMON.expSessionKey);
      try {
        return JSON.parse(newSession);
      } catch (err) {
        return newSession;
      }
    } else {
      return undefined;
    }
  }

  /**
 * Makes /v2/filteredExperiments API call
 * Saves data in window.sessionStorage under key 'ExpMetaData'
 * eg https://exp-core-mcom.staging.devops.fds.com/v2/filteredExperiments
 */
  static callExperimentationAPIAsync = async () => {
    let api = `https:${ExpUtils.getApiEndpoint()}`;
    let cookie = Cookie.get(ExpUtils.PROPS.COMMON.expCookieName);
    if (cookie) cookie = escape(cookie);
    let sid;

    if (!cookie) {
      sid = '';
    } else {
      sid = `?sid=${cookie}`;
    }
    api += `/filteredExperiments${sid}`;

    if (api) {
      const response = await fetchJsonp(api, { timeout: 20000 });
      const data = await response.json();
      this.saveExpAPIResponse(data);

      return data;
    }
    return undefined;
  }

  /**
  * Keep session of selected recipes in session
  * @param {*} response
  * @returns
  * Usage:
  */
  static saveExpAPIResponse = (response) => {
    let respObj;
    const expData = response.experiment;
    const { selectedRecipes } = response;
    if (ExpUtils.isArray(expData)) {
      respObj = ClientSideStorageWrapper.mapResponse(expData, selectedRecipes);
      ClientSideStorageWrapper.setExpSession(ExpUtils.PROPS.COMMON.expSessionKey, respObj);
    }
    return respObj;
  }

  /**
  * Is experimentation fired tags session expired
  * When adobe tags were fired, that session was saved. Checks session validity
  * @returns {boolean}
  */
  static isExpTagsSessionExpired = () => {
    const session = ClientSideStorageWrapper.getExpTagsSession(ExpUtils.PROPS.COMMON.expTagsFiredSessionKey);
    const now = new Date().getTime();
    // Remove Session Variable when expire
    // ttl = expire - now
    if (session && session.split('|')[1] - now < 0) {
      ClientSideStorageWrapper.removeExpTagsSession(ExpUtils.PROPS.COMMON.expTagsFiredSessionKey);
      return true;
    }
    return false;
  }

  /**
  * Is userid in session same as in cookie
  * @returns {booalen}
  */
  static isSignedInSame = () => {
    const session = ClientSideStorageWrapper.getExpSession(ExpUtils.PROPS.COMMON.expSessionKey);
    let cookieVal;

    if (ExpUtils.PROPS.brand === undefined) {
      ExpUtils.setBrand();
    }

    if (ExpUtils.PROPS.brand && ExpUtils.PROPS.brand === 'bcom') {
      cookieVal = ExpUtils.getCookieForExperiment('bloomingdales_online_uid');
    } else {
      cookieVal = ExpUtils.getCookieForExperiment('macys_online_uid');
    }
    if (cookieVal === undefined || cookieVal === null) {
      cookieVal = 0;
    }
    if (
      session !== undefined
      && session.signedInUser !== undefined
      && cookieVal === session.signedInUser
    ) {
      return true;
    }
    return false;
  }
};
